import Logo from "@/ui/components/Logo";
import { useEffect, useMemo } from "preact/hooks";
import { postEvent } from "@/lib/api_controller";
import { TaaliaEvent } from "@/lib/event_types";
import { getL11nString } from "@/l11n/l11n";

const OpenInBrowser = () => {
  const url = window.location.href;
  const urlWithoutQueryParams = url.split("?")[0];

  useEffect(() => {
    postEvent(TaaliaEvent.openInBrowserDisplayed, {
      url,
      userAgent: navigator.userAgent,
    });
  }, []);

  // MARK: Local L11N
  const strings = useMemo(
    () => ({
      open_in_browser: getL11nString("open_in_browser"),
      open_in_browser_detail: getL11nString("open_in_browser_detail"),
      or_copy_and_paste_url: getL11nString("or_copy_and_paste_url"),
    }),
    []
  );

  return (
    <div className="flex flex-col items-center justify-center p-6 text-center space-y-4">
      <Logo className="w-16 h-16 mb-4" />
      <h2 className="text-xl font-semibold mb-4">{strings.open_in_browser}</h2>
      <div
        className="mb-4 text-sm text-gray-600 max-w-xs flex flex-col gap-3"
        dangerouslySetInnerHTML={{ __html: strings.open_in_browser_detail }}
      />
      <div className="mt-4 text-xs text-gray-500 max-w-xs">
        <p className="mb-2">{strings.or_copy_and_paste_url}</p>
        <code className="block p-2 bg-gray-100 rounded break-all">
          {urlWithoutQueryParams}
        </code>
      </div>
    </div>
  );
};

export default OpenInBrowser;

{
  /* <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className="px-4 py-2 bg-blue-600 text-white rounded-lg text-sm shadow hover:bg-blue-700 transition-colors"
        onClick={async () =>
          await postEvent(TaaliaEvent.openInBrowserClicked, {
            url,
            userAgent: navigator.userAgent,
          })
        }
      >
        {strings.open_in_browser}
      </a> */
}
